const C = "adyen-pe-accordion", _ = C + "__header", A = _ + "-container", O = _ + "-controller", n = C + "__content";
export {
  C as ACCORDION_BASE_CLASS,
  n as ACCORDION_CONTENT_CLASS,
  _ as ACCORDION_HEADER_CLASS,
  A as ACCORDION_HEADER_CONTAINER_CLASS,
  O as ACCORDION_HEADER_CONTROLLER_CLASS
};
